export default __webpack_public_path__ + "static/media/github.15c9dcd7.svg";